import {
  IArrivalTime,
  ICachedArrivalTime,
} from "@/domain/entities/lineInfo/arrivalTime.types";
import dayjs from "dayjs";
import { ref } from "vue";

export const useCachedArrivalTime = (
  maxCachedCount: number,
  cacheExpirySeconds: number
) => {
  const cachedArrivalTimes = ref<ICachedArrivalTime[]>([]);

  /** 캐싱된 데이터 업데이트 */
  const refreshCachedArrivalTimes = (data: IArrivalTime[], key: string) => {
    const timeStamp = dayjs().format("YYYY-MM-DD HH:mm:ss");

    if (cachedArrivalTimes.value.length >= maxCachedCount) {
      cachedArrivalTimes.value.splice(0, 1);
    }

    cachedArrivalTimes.value = [
      ...cachedArrivalTimes.value,
      {
        key: key,
        data,
        timeStamp,
      },
    ];
  };

  /** 캐싱된 데이터 지우기 */
  const removeCachedArrivalTime = (key: string) => {
    cachedArrivalTimes.value = cachedArrivalTimes.value.filter(
      (data) => data.key !== key
    );
  };

  /** 캐싱된 데이터 가져오기 */
  const getCachedArrivalTime = (key: string) => {
    const data = cachedArrivalTimes.value.find((cached) => cached.key === key);

    return data;
  };

  const isFresh = (key: string) => {
    const cachedIndex = cachedArrivalTimes.value.findIndex(
      (cached) => cached.key === key
    );

    if (cachedIndex === -1) return false;

    const target = cachedArrivalTimes.value[cachedIndex];
    return dayjs().diff(dayjs(target.timeStamp), "second") < cacheExpirySeconds;
  };

  return {
    cachedArrivalTimes,
    getCachedArrivalTime,
    refreshCachedArrivalTimes,
    removeCachedArrivalTime,
    isFresh,
  };
};
